module.exports = __webpack_public_path__ + "img/39.43c1a6f0.jpg";